<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- availability matrix form -->
<template>
  <div class="availability-form">
    <div class="appointment-type-availability">
      <!-- Appointment Type Name -->
      <div class="appointment-type-availability-header">
        <h5>{{ userAvailability.name }}</h5>
        <a class="shaded" @click="beginEditingAvailability"><i class="fal fa-edit"></i>Edit</a>
      </div>

      <!-- Days -->
      <div class="day-heading">
        <div class="day">Monday</div>
        <div class="day">Tuesday</div>
        <div class="day">Wednesday</div>
        <div class="day">Thursday</div>
        <div class="day">Friday</div>
      </div>

      <!-- Indicators -->
      <div
        v-for="av in userAvailability.availability"
        :key="av.appointmentTypeOffering.id"
        class="appointment-type-offering-availability"
      >
        <div class="offering-time">{{ parseTime(av.appointmentTypeOffering.hour) }}</div>
        <div class="day" v-for="day in days" :key="day">
          <i class="fal fa-check-circle" v-if="av.days.includes(day)"></i>
          <i class="fal fa-times" v-else></i>
        </div>
      </div>
    </div>

    <!-- Form to edit -->
    <av-modal :visible="editing" @close="editing = false">
      <div class="appointment-type-availability-header">
        <h5>{{ userAvailability.name }}</h5>
      </div>

      <div class="day-heading">
        <div class="day">Mon</div>
        <div class="day">Tue</div>
        <div class="day">Wed</div>
        <div class="day">Thur</div>
        <div class="day">Fri</div>
      </div>

      <av-checkbox-group
        v-for="av in editedAvailability.availability"
        :key="av.appointmentTypeOffering.id"
        v-model="av.days"
      >
        <div class="appointment-type-offering-availability form">
          <div class="offering-time">{{ parseTime(av.appointmentTypeOffering.hour) }}</div>
          <div class="day" v-for="day in days" :key="day">
            <av-checkbox :value="day"></av-checkbox>
          </div>
        </div>
      </av-checkbox-group>

      <div class="modal-actions">
        <av-button class="error hollow" @click="editing = false">Cancel</av-button>
        <av-button @click="saveAvailability">Save</av-button>
      </div>
    </av-modal>
  </div>
</template>

<script lang="ts">
import { cloneDeep } from 'lodash'
import { defineComponent, PropType } from 'vue'
import TimeService from '../common/timeService'
import UserService from '../common/userService'
import UserAvailabilityByType from '../models/userAvailabilityByType'

export default defineComponent({
  name: 'AvailabilityForm',

  props: {
    /** The availability to view and edit */
    userAvailability: {
      type: Object as PropType<UserAvailabilityByType>,
      required: true
    },

    /** The Id of the user who owns the availability */
    userId: {
      type: Number,
      required: true
    }
  },

  emits: ['update-availability'],

  data () {
    return {
      /** Day enum values */
      // days: [1, 2, 4, 8, 16],
      days: ['M', 'T', 'W', 'TH', 'F'],

      /** Indicates that availability is being edited */
      editing: false,

      /** An copy of the availability to edit */
      editedAvailability: null as unknown as UserAvailabilityByType
    }
  },

  methods: {
    /**
     * Resets the edited availability and shows the form.
     */
    beginEditingAvailability () {
      console.log(this.userAvailability.availability)
      this.editedAvailability = cloneDeep(this.userAvailability)
      this.editing = true
    },

    /**
     * Returns a string for the given time represented as the number of minutes past the start of day
     * @param timeNumb: Number of minutes past the start of day
     */
    parseTime (timeNum: number): string | null {
      return TimeService.convertTimeToString(timeNum)
    },

    /**
     * Updates the edited availability
     */
    saveAvailability () {
      UserService.updateAvailability(this.userId, this.editedAvailability.availability).then(res => {
        this.$emit('update-availability', res.data.availability)
        this.editing = false
      })
    }
  }
})
</script>
